export const version = 'kunde-v1.14.3';